import { useRuntimeConfig } from "#imports";
export function getDefaultAttributes() {
  const config = useRuntimeConfig().public.logger;
  return {
    environment: config.environment,
    continent: config.continent,
    source: import.meta.server ? "node" : "browser",
    service: {
      name: config.service,
      version: config.buildImage.version,
      build: {
        timestamp: config.buildImage.timestamp,
        sha: config.buildImage.sha
      }
    }
  };
}
